
import React, { lazy, Suspense } from "react";



import {createBrowserRouter,RouterProvider,BrowserRouter,Routes,Route} from 'react-router-dom';
import  Login  from "./Components/Login";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import  Layout  from "./Components/Layout";

/*LAB IMPORTS*/
const LabLayout = lazy(() => import("./Components/LabLayout"));
const Research = lazy(() => import("./Components/Lab/Research"));
const Experiments = lazy(() => import("./Components/Lab/Experiments"));
const Projects = lazy(() => import("./Components/Lab/Projects"));
const Infrastructure = lazy(() => import("./Components/Lab/Infrastructure"));
const Publications = lazy(() => import("./Components/Lab/Publications"));
const Blogs = lazy(() => import("./Components/Lab/Journals"));
const Journal = lazy(() => import("./Components/Lab/Journal"));
const JournalsPreview = lazy(() => import("./Components/Lab/JournalsPreview"));
const JournalPreview = lazy(() => import("./Components/Lab/JournalPreview"));
const About = lazy(() => import("./Components/Lab/About"));
const MachineIntelligence = lazy(() => import("./Components/Lab/MachineIntelligence"));
const Mlops = lazy(() => import("./Components/Lab/Mlops"));
const EnterpriseAI = lazy(() => import("./Components/Lab/EnterpriseAI"));

const StudioDashboard = lazy(() => import("./Components/Studio/StudioDashboard"));
const CreateBlog = lazy(() => import("./Components/Studio/CreateBlog"));
const CreatePublication = lazy(() => import("./Components/Studio/CreatePublication"));
const CreateProject = lazy(() => import("./Components/Studio/CreateProject"));
const ManageProjects = lazy(() => import("./Components/ManageProjects"));
const EditProjectEditor = lazy(() => import("./Components/Studio/EditProject"));
const Project = lazy(() => import("./Components/Studio/Project"));

/* Old Imports */
const Reset = lazy(() => import("./Components/Reset"));
const PasswordReset = lazy(() => import("./Components/ResetPassword"));
const LoginPasswordReset = lazy(() => import("./Components/LoginReset"));
const Root = lazy(() => import("./Components/Root"));
// import { Blogs } from './Components/Blogs';
//const Blog = lazy(() => import("./Components/Blog"));
const Casestudies = lazy(() => import("./Components/Casestudy"));
const Case = lazy(() => import("./Components/Case"));
const Glossary = lazy(() => import("./Components/Glossary"));
const GlossaryTerm = lazy(() => import("./Components/GlossaryTerm"));
const Contact = lazy(() => import("./Components/Contact"));
const PublicationPreview = lazy(() => import("./Components/PublicationPreview"));
const PublicationsPreview = lazy(() => import("./Components/PublicationsPreview"));


const lazyLoad = (name, importer) =>
  React.lazy(() =>
    importer().then((module) => {
      console.log(name, module);

      if (!module.default) {
        console.error(`${name} has no default export`, module);
      }

      return module;
    })
  );

const Kubernetes = lazyLoad(
  "Vacancies",
  () => import("./Components/Vacancies")
);

const EditBlogEditor = lazy(() => import("./Components/EditBlog"));
const ManageBlogs = lazy(() => import("./Components/ManageBlogs"));
const ManageWhitePapers = lazy(() => import("./Components/ManageWhitePapers"));

const Vacancies = lazy(() => import("./Components/Vacancies"));
const Vacancy = lazy(() => import("./Components/Vacancy"));

const CreateVacancy = lazy(() => import("./Components/createVacancy"));
const EditVacancyEditor = lazy(() => import("./Components/editVacancy"));
const ManageVacancies = lazy(() => import("./Components/ManageVacancies"));

//const StudioDashboard = lazy(() => import("./Components/Studio/StudioDashboard"));


function App() {

  const dispatch = useDispatch()

  useEffect(()=>{
      
  },[])
  return <BrowserRouter>
  {/* All routed components will be passed as children to Mainlaout*/}

  <Suspense fallback={
    <div className="loading-screen">
      <img src="/vectors4d_logo_circuit_brain.svg" alt="Vectors4D" className="loading-logo" />
    </div>}>      
      <Routes>
          <Route element={<LabLayout/>}>

            <Route 
                path="/"
                element={<Root/>}
            />


            <Route
                path="/services/research"
                element={<Research/>}
            />

            <Route
                path="/services/mlops"
                element={<Mlops/>}
            />

            <Route
                path="/services/enterprise-ai"
                element={<EnterpriseAI/>}
            />


            <Route
                path="/experiments"
                element={<Experiments/>}
            />


            <Route
                path="/projects"
                element={<Projects/>}
            />


             <Route
                path="/contact"
                element={<Contact/>}
            />

            <Route path="/vacancies" element={<Vacancies />} />
                    

            <Route
                path="/infrastructure"
                element={<Infrastructure/>}
            />


            <Route
                path="/publications"
                element={<Publications/>}
            />


            <Route
                path="/blogs"
                element={<Blogs/>}
            />

            <Route path="/journalsPreview" element={<JournalsPreview />} />
            <Route path="/PublicationsPreview" element={<PublicationsPreview />} />

            <Route
                path="/about"
                element={<About/>}
            />

            <Route 
            
            path="/machineintelligence"
            element={<MachineIntelligence/>}
            >

            </Route>


        </Route>
          
          <Route path="/login" element={<Login></Login>}></Route>
          <Route path="/blog/:id" element={<Journal />} />
          <Route path="/project/:id" element={<Project />} />
          <Route path="/vacancy/:id" element={<Vacancy />} />
          <Route path="/PublicationPreview/:id" element={<PublicationPreview />} />
          <Route path="/journalPreview/:id" element={<JournalPreview />} />
          <Route path="/casestudy" element={<Casestudies/>}></Route>
          <Route path="/Case" element={<Case></Case>}></Route>
          <Route path="/Glossary" element={<Glossary></Glossary>}></Route>
          <Route path="/GlossaryTerm" element={<GlossaryTerm></GlossaryTerm>}></Route>
          <Route path="/reset" element={<Reset></Reset>}></Route>
          <Route path="/resetPassword" element={<PasswordReset></PasswordReset>}></Route>
          <Route path="/LoginPasswordReset" element={<LoginPasswordReset/>}></Route>
          <Route element={<Layout/>}>
            <Route path='/studio' element={<StudioDashboard></StudioDashboard>}></Route>
            <Route path="/createBlog" element={<CreateBlog/>}></Route>
            <Route path="/createProject" element={<CreateProject/>}></Route>
            <Route path="/editblog/:id" element={<EditBlogEditor />} />
            <Route path="/CreatePublication" element={<CreatePublication/>}></Route>
            <Route path="/manageBlogs" element={<ManageBlogs />} />
            <Route path="/manageProjects" element={<ManageProjects />} />
            <Route path="/editproject/:id" element={<EditProjectEditor />} />
            <Route path="/editpublication/:id" element={<CreatePublication/>}></Route>
            <Route path="/managewhitepapers" element={<ManageWhitePapers />} />
            <Route path="/createvacancy" element={<CreateVacancy />} />
            <Route path="/editvacancy/:id" element={<EditVacancyEditor />} />
            <Route path="/managevacancies" element={<ManageVacancies />} />
          </Route>
        </Routes>
         </Suspense>
  </BrowserRouter>
  
  ;
}

export default App;
